<template>
    <el-dialog
        :visible.sync="dialogVisible"
        :title="'查看账户运营负责人 - '+account.user_name"
        width="800px"
        :close-on-press-escape="false"
        append-to-body
        :before-close="handleClose">
        <div style="width: 90%;margin:0 auto;">
            <el-table
                v-loading="dataLoading"
                :max-height="250"
                :data="dataList">
                <el-table-column
                    align="center"
                    prop="name"
                    label="运营">
                </el-table-column>
                <el-table-column
                    align="center"
                    prop="operation_time"
                    label="负责开始时间">
                </el-table-column>
            </el-table>
        </div>
    </el-dialog>
</template>

<script>
    import API from '@/api/mediaAccount.js';
    import matomo from '@/utils/matomo.js'
    export default {
        name: "YYHistoryModal",
        components:{
        },
        props:{
            account:{
                required:true,
                type:Object,
            },
        },
        data() {
            return {
                dialogVisible: false,
                dataList:[],
                dataLoading:false,
            }
        },
        computed: {},
        methods: {
            handleClose() {
                matomo.trackEvent('媒体账户绑定', '点击', '列表(设置运营-关闭)');
                this.dialogVisible = false;
                this.dataList = [];
            },
            showModal() {
                this.dialogVisible = true;
                this.$nextTick(()=>{
                    this.getYYHistory();
                })
            },
            getYYHistory(){
                this.dataLoading = true;
                API.getYYHistory({
                    plat_id:this.account.plat_id,
                    company_id:this.account.company_id,
                }).then(res => {
                    this.dataList = res.data || [];
                    this.dataLoading = false;
                }, (err) => {
                    console.log('getYYHistory error', err);
                    this.dataList = [];
                    this.dataLoading = false;
                });
            },

        }
    }
</script>

<style lang="scss" scoped>

    ::v-deep .el-dialog__body{
        padding-top: 5px;
    }
</style>
